// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-183b63ee] .orange-icon {\r\n  font-size: 18pt;\n}\r\n", ""]);
// Exports
module.exports = exports;
